module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/containers/search-container/search-container.style.scss
// module id = 879
// module chunks = 2